<template src="./pariCodice.html"></template>

<script>
import {
  get_dettaglioVariantiPariCodice,
  set_dettaglioVariantiPariCodice,
  set_dettaglioVariantiPariCodice_coprifili,
  set_dettaglioVariantiPariCodice_battute
} from "@/api/api.ordini.js";

export default {
  props: {
    dialog: { type: Boolean, default: false },
    idPrev: { type: Number, default: 0 },
    scheda: { type: Number, default: 0 },
    prog: { type: Number, default: 0 },
    sezione: { type: Number, default: 0 },
    progVariante: { type: Number, default: 0 },
    codArticolo: { type: String, default: "" },
    tipo: { type: String, default: "" },
    valoriBattute: { type: Array, default: () => [] }
  },

  data: () => ({
    attesa: false,
    attesaCaricamento: false,

    selected: [],
    headers: [
      { text: "Prog", value: "Prog", width: '90px' },
      { text: "codSerie", value: "CodSerie" },
      { text: "Progetto", value: "CodProgetto" },
      { text: "Descrizione", value: "DescProgetto" },
      { text: "Articolo", value: "ArticoloTrovato" }
    ],
    dati: [],

    radioOpearazione: "",
  }),

  methods: {
    async caricaDati() {
      // Reset
      this.dati = [];
      this.selected = [];
      this.radioOpearazione = "aggiorna";

      if (this.dialog == false) return;

      this.attesaCaricamento = true;

      try {
        let res = await get_dettaglioVariantiPariCodice(this.idPrev + "/" + this.scheda + "/" + this.prog + "/" + this.sezione + "/" + this.progVariante);

        this.dati = res.data;

        // Sui coprifilo\battute visualizzo solo quelli di medesima serie
        if (this.tipo == "coprifilo_interno" || this.tipo == "coprifilo_esterno" || this.tipo == "battute") {
          let serieSel = this.dati.find(f => f.Prog == this.prog).CodSerie
          this.dati = this.dati.filter(f => f.CodSerie == serieSel)
        }

        // Nascondo la colonna visualizzata dalle battute (se avessero usato precedentemente paricodice battute)
        let swapIndex = this.headers.findIndex(f => f.text == 'Telaio')
        if (swapIndex > 0)
          this.headers.splice(swapIndex)

        // Nel caso di battute visualizzo una colonna in più (viene tolta prima)
        if (this.tipo == "battute")
          this.headers.push({ text: "Telaio", value: "TipoBattuta" })



      } catch (error) {
        console.log(error);
      }

      this.attesaCaricamento = false;

    },

    async salva() {
      // Validazione
      if (this.selected == false) {
        this.$toast.alert("Nessun rigo selezionato");
        return;
      }

      // Conferma
      let confirm = await this.$confirm.open(
        "Applica articolo",
        "Vuoi eseguire l'operazione sulle posizioni selezionate ?"
      );
      if (!confirm) return;

      this.attesa = true;

      let contData = 0;


      if (this.tipo == "coprifilo_interno" || this.tipo == "coprifilo_esterno") {
        // --------------------
        // Coprifili
        // --------------------
        contData = await this.pariCodice_coprifili()

      }
      else if (this.tipo == "battute") {
        // --------------------
        // Battute
        // --------------------
        contData = await this.pariCodice_battute()

      }
      else {
        // --------------------
        // Varianti
        // --------------------
        contData = await this.pariCodice_varianti()

      }

      this.attesa = false;

      this.chiudi(contData);
    },

    async pariCodice_varianti() {

      let contData = 0;

      try {
        let par =
          this.radioOpearazione +
          "/" +
          this.idPrev +
          "/" +
          this.scheda +
          "/" +
          this.prog +
          "/" +
          this.sezione +
          "/" +
          this.progVariante;

        let res = await set_dettaglioVariantiPariCodice(par, this.selected);

        contData = res.data;

      } catch (error) {
        console.log(error);
        this.$toast.alert(this.$i2kFunctions.getErrorMsg(error));
      }

      return contData
    },

    async pariCodice_coprifili() {
      let contData = 0;

      try {
        let par =
          this.radioOpearazione +
          "/" +
          this.idPrev +
          "/" +
          this.scheda +
          "/" +
          this.prog +
          "/" +
          this.tipo

        let res = await set_dettaglioVariantiPariCodice_coprifili(par, this.selected);

        contData = res.data;
      } catch (error) {
        console.log(error);
        this.$toast.alert(this.$i2kFunctions.getErrorMsg(error));
      }
      return contData
    },

    async pariCodice_battute() {

      let contData = 0;

      try {
        let par =
          this.radioOpearazione +
          "/" +
          this.idPrev +
          "/" +
          this.scheda +
          "/" +
          this.prog

        let data = { Dettaglio: this.selected, VariantiProduzione: this.valoriBattute }

        let res = await set_dettaglioVariantiPariCodice_battute(par, data);

        contData = res.data;
      } catch (error) {
        console.log(error);
        this.$toast.alert(this.$i2kFunctions.getErrorMsg(error));
      }
      return contData
    },


    chiudi(res) {
      this.$emit("chiudiDialog", res);
    },

    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.dati.slice();
    },
  },

  mounted() {
    this.caricaDati();
  },

  watch: {
    dialog(val) {
      this.caricaDati();
    },
  },
};
</script>